import { AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions, TableRowUpdate, AimsCommonTableFilterType } from '@aims/common-components';
import { Component, Input } from '@angular/core';
import { Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MainGridService } from 'src/app/components/maingrid/main-grid.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { CacheItem, TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { AllLocations, AllSites } from 'src/models';
import { GetTextPipe } from 'src/app/pipes';



@Component({
  selector: 'aims-config-locations',
  templateUrl: './config-locations.component.html',
  styleUrls: ['./config-locations.component.css'],
  providers: [ MainGridService, GetTextPipe ],
})
export class ConfigLocationsComponent {

  @Input() permissionNeeded: number;

  resources: Observable<any>
  initialTableObject: AllLocations;
  locationLookup
  locationLookupColumns
  header: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'active', label: 'Active', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN },
    { key: 'location', label: 'Location Name', type: AimsCommonTableHeaderType.STRING, validatorOrOpts: [Validators.required] },
    { key: 'siteId', label: 'Site', type: AimsCommonTableHeaderType.DYNAMIC, filterType: AimsCommonTableFilterType.DYNAMIC,
       events: { 
        filterAndSortCompare: (term, el) => term === el.siteId, 
        filterAndSort:(element) => this.getTextPipe.transform(element.siteId, 'siteId', 'siteName', this.sites)
        },
       validatorOrOpts: [Validators.required] }
  ]  
  sites = this.transferHttp.getCache<Array<AllSites>>(CacheItem.sites);
  sitesCache;
  tablePermissions: Observable<AimsCommonTablePermissions>;

  constructor(private transferHttp: TransferHttpService,
    public permissions: PermissionsService,
    public mainGridService: MainGridService<any>,
    private getTextPipe: GetTextPipe) {
      this.initialTableObject = new AllLocations();
      this.initialTableObject.siteId = null;
      this.initialTableObject.active = true;
      this.resources = this.mainGridService.getAll('Facilities/GetLocations', 'Facilities/SaveLocation'); 
      this.locationLookup = this.resources.pipe(
        map(locArr => locArr.map(l => {
          return { siteName: this.sites.filter(s => s.siteId == l.siteId)[0].siteName, location: l.location, locationId: l.locationId }
        }))
      );

      this.locationLookupColumns = [
        { id: 'siteName', title: 'Site', filterable: true },
        { id: 'location', title: 'Location', filterable: true }
      ];
  }

  handleRowUpdate(update: TableRowUpdate): void {
    this.mainGridService.update(update.newRow, update.index).subscribe(update.handleSubscribe())
  }

  handleRowAdd(update: TableRowUpdate): void {
    this.mainGridService.add(update.newRow).subscribe(update.handleSubscribe())
  }

  ngOnInit() {
    this.tablePermissions = this.permissions.getDataGridPerms$(this.permissionNeeded, { export: false, delete: false });
  }
}
